module.exports = __webpack_public_path__ + "img/content1.0bb97e16.png";